import { Tooltip, PlacesType } from 'react-tooltip';
import { isDesktop } from 'react-device-detect';
import styles from './HoverTooltip.module.scss';
import { HOVER_TOOLTIP_ID } from 'src/constants';
import { PortalWrapper } from 'src/components/PortalWrapper';
import classNames from 'classnames';

interface HoverTooltipProps {
  place?: PlacesType;
  noArrow?: boolean;
  offset?: number;
  id?: string;
  className?: string;
  isOpen?: boolean;
  shouldShowForMobile?: boolean;
}

/**
 * For passing content we should use data-tooltip-content in the trigger, and data-tooltip-id for link tooltip ID with trigger.
 */
export const HoverTooltip = ({
  place,
  noArrow,
  offset,
  id,
  className,
  isOpen,
  shouldShowForMobile,
}: HoverTooltipProps) => {
  if (!isDesktop && !shouldShowForMobile) {
    return null;
  }

  return (
    <PortalWrapper>
      <div className={styles.root}>
        <Tooltip
          closeEvents={{
            click: true,
            mouseleave: true,
            mouseout: true,
            blur: true,
            dblclick: true,
            mouseup: true,
          }}
          globalCloseEvents={{
            clickOutsideAnchor: true,
            scroll: true,
            escape: true,
          }}
          openEvents={isOpen === undefined ? { mouseover: true } : {}}
          id={id || HOVER_TOOLTIP_ID}
          noArrow={noArrow}
          className={classNames(styles.tooltip, className)}
          place={place}
          opacity={1}
          offset={offset}
          isOpen={isOpen}
        />
      </div>
    </PortalWrapper>
  );
};
